import { Random } from '@framework/Random';
import type { AnnotationLinkId } from 'balus-common';

const length = 20;
export const newAnnotationLinkId = (): AnnotationLinkId => Random.generateRandomID(length, 'AL');
